// Helper functions for dynamic table value formatting
//
// Usage:
// - For plain text: formatValue(value) returns string
// - For HTML content: pass { __html: '<span class="badge">HTML</span>' }
// - Or use createHtmlValue('<span class="badge">HTML</span>')

export function formatValue(value) {
  switch (true) {
    case typeof value === 'boolean':
      return value ? 'Yes' : 'No'
    case !value:
      return '-'
    case Array.isArray(value):
      return value.join(', ')
    case typeof value === 'object' && value !== null:
      // Check if it's an HTML object with __html property
      if (value.__html !== undefined) {
        return value // This will be handled by dangerouslySetInnerHTML
      }
      // Check if it has a label property (existing behavior)
      if (value.label !== undefined) {
        return value.label
      }
      return JSON.stringify(value)
    default:
      return value
  }
}

// Helper function to create HTML content
export function createHtmlValue(htmlString) {
  return { __html: htmlString }
}
